import { Overwrite } from 'utility-types';

import { FeatureFlag, FeatureFlagConfig } from '@app/contexts';
import { Feature, FeatureFlagToMatch } from '@app/constants';

export const getMatchedFeatureFlag = <T extends Feature>({
  flags,
  flagToMatch: { name, isActiveIfNotFound = false },
}: {
  flags: FeatureFlag[];
  flagToMatch: FeatureFlagToMatch<T>;
}) => {
  const matchedFlag = flags.find(flag => flag.name === name) ?? {
    name,
    isActive: isActiveIfNotFound,
  };

  return { config: {}, ...matchedFlag } as Overwrite<
    FeatureFlag<T>,
    { config: FeatureFlagConfig<T> }
  >;
};
